import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	totalSummaryLabel: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-footer.total-summary-label',
		defaultMessage: 'Total',
		description: 'total summary label',
	},
});
